
import {Options, Vue} from "vue-class-component";

@Options({
  props: {
    modelValue: String
  },
})
export default class AppMeTextarea extends Vue {}
